import {ImgIcon} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcon';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';
import {InputLabel} from '@mintdata/mint-kit/impl/properties/components/inputLabel/InputLabel';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/checkbox/Checkbox.less');
const cx = classnames.bind(styles);

export enum CheckboxStyle
{
    Default = 'defaultStyle',
    Toggler = 'togglerStyle'
}

export enum CheckboxInlineLabelPosition
{
    Left = 'Left',
    Right = 'Right'
}

export interface ICheckboxProps
{
    disabled?:boolean;
    isChecked:boolean;
    inlineLabel?:string | JSX.Element;
    inlineLabelPosition?:CheckboxInlineLabelPosition;
    label?:string | JSX.Element;
    style?:CheckboxStyle;
    onClick:(event:React.MouseEvent<HTMLElement>) => void;
}

export class Checkbox extends React.Component<ICheckboxProps, any>
{
    public render():JSX.Element
    {
        const {
            onClick,
            isChecked,
            disabled = false,
            label,
            inlineLabel,
            inlineLabelPosition = CheckboxInlineLabelPosition.Right,
            style = CheckboxStyle.Default
        } = this.props;

        const inlineLabelElement:JSX.Element = typeof inlineLabel === 'string'
            ? (
                <div className={cx('inlineLabel', {
                    left: inlineLabelPosition === CheckboxInlineLabelPosition.Left,
                    right: inlineLabelPosition === CheckboxInlineLabelPosition.Right
                })}>{inlineLabel}</div>
            )
            : inlineLabel;

        return (
            <div>
                <button className={cx('base', style, {isChecked, isDisabled: disabled})} onClick={onClick}>
                    {inlineLabelPosition === CheckboxInlineLabelPosition.Left ? inlineLabelElement : null}
                    {
                        style === CheckboxStyle.Default ? (
                            <div className={styles.iconWrapper}>
                                <ImgIcon icon={ImgIcons.check} className={styles.checkbox} />
                            </div>
                        ) : (
                            <div className={styles.togglerWrapper}>
                                <div className={styles.toggler} />
                            </div>
                        )
                    }
                    {inlineLabelPosition === CheckboxInlineLabelPosition.Right ? inlineLabelElement : null}
                </button>
                {
                    typeof label === 'string' ? (
                        <div className={styles.label}>
                            <InputLabel text={label} />
                        </div>
                    ) : label
                }
            </div>
        );
    }
}

